<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="c-form-item c-form-item-quick-date-range-picker flex" v-bind="{ ...wrapperAttrs }">
    <div class="flex-main">
      <c-date-range-picker
        v-model:from="model[prop]"
        v-model:to="model[toProp]"
        v-bind="innerAttrs"
        :disabled="disabled"
        @change="handleChange"
      />
    </div>

    <div class="quick-buttons flex q-ml-md">
      <el-button class="button" plain @click="setQuickDate(0, 0)">今日</el-button>
      <el-button class="button" plain @click="setQuickDate(-1, -1)">昨日</el-button>
      <el-button class="button" plain @click="setQuickDate(-7, -1)">近7日</el-button>
    </div>
    <el-form-item :prop="toProp"></el-form-item>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { inject, dateUtil } from '@zto/zpage'
import { C_FORM_KEY, useFormItem } from '@zto/zpage-ui-element'

const cForm = inject<any>(C_FORM_KEY, null)

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    toProp: string
    disabled?: boolean
    wrapperAttrs?: Record<string, any>
  }>(),
  {
    disabled: false
  }
)

const { innerAttrs } = useFormItem(props)

// 值发生变化后，调用form的校验，解决值发生变化后没校验的问题
function handleChange() {
  if (cForm) {
    cForm.validateFields([props.prop, props.toProp])
  }
}

/**
 * 设置快捷时间
 */
function setQuickDate(startDays: number, endDays: number) {
  const nowDate = new Date()
  const startDate = dateUtil.startOf(dateUtil.addDays(nowDate, startDays))
  const endDate = dateUtil.endOf(dateUtil.addDays(nowDate, endDays))

  props.model[props.prop] = startDate
  props.model[props.toProp] = endDate
}
</script>

<style lang="scss" scoped>
.c-form-item {
  display: flex;
}

.quick-buttons {
  & > .button {
    height: 28px;
    padding: 7px;
  }
}
</style>
